export const PAY_TO = {
  ACCOMMODATION_PROVIDER: 'accommodation-provider',
  US: 'us'
};
